import React from 'react';
import { SvgIcon } from 'ui/SvgIcon';
import ExclamationCircleIcon from 'ui/Icons/tabler/exclamation-circle.component.svg';

interface IErrorMessageProps {
  message: string;
}

export const ErrorMessage = React.memo(({ message }: IErrorMessageProps) => {
  return (
    <div className="bg-red-20 text-red-100 text-center font-pt-sans p-4 mb-4 absolute top-0 left-0 w-full flex items-center justify-center gap-2">
      <SvgIcon IconComponent={ExclamationCircleIcon} className="w-4 h-4 fill-red-100" />
      <span>{message}</span>
    </div>
  );
});
